import { render, staticRenderFns } from "./InventoryCheckTable.vue?vue&type=template&id=fb1472e0&scoped=true&"
import script from "./InventoryCheckTable.vue?vue&type=script&lang=js&"
export * from "./InventoryCheckTable.vue?vue&type=script&lang=js&"
import style0 from "./InventoryCheckTable.vue?vue&type=style&index=0&id=fb1472e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb1472e0",
  null
  
)

export default component.exports